<template>
	<div class="pushSoftAskWrapper">
		<div class="leftBox">
			<div class="logo" />
		</div>
		<div class="rightBox">
			<div class="headerText">
				{{ $t('webPush.softAsk.headerText') }}
			</div>
			<div class="subText">
				{{ $t('webPush.softAsk.subText') }}
			</div>
			<div class="buttonWrapper decline">
				<ButtonComponent
					class="declineButton w-full"
					color="secondary"
					size="medium"
					@click="decline"
				>
					{{ $t('webPush.softAsk.declineButton') }}
				</ButtonComponent>
			</div>
			<div class="buttonWrapper accept">
				<ButtonComponent
					class="acceptButton w-full"
					color="primary"
					size="medium"
					@click="accept"
				>
					{{ $t('webPush.softAsk.acceptButton') }}
				</ButtonComponent>
			</div>
		</div>
	</div>
</template>

<script src='./index.ts'></script>

<style lang="less" scoped>
@import '~lessVars';
@import '../../../css/components/button.less';

.pushSoftAskWrapper {
	display: flex;
	background: #fff;
	max-width: 100%;
	width: 400px;
	padding: 20px;
	margin-top: 30vh;
	margin-left: auto;
	margin-right: auto;
	text-align: left;

	& when(@brand="Hema") {
		font-size: @fontSize_XS;
		line-height: 23px;
	}
}

.logo {
	position: relative;
	background-size: contain;

	& when(@brand="Hema") {
		background-image: url('../../../img/hema/logo.svg');
		width: 50px;
		height: 50px;
	}
}
.rightBox {
	padding-left: 20px;

	& when(@brand="Hema") {
		padding-top: 60px;
	}

	.headerText,
	.subText {
		width: 100%;
		float: left;
	}
	.headerText {
		font-family: @fontFamilyBold;
		font-weight: @fontWeightBold;

		& when(@brand="Hema") {
			font-family: @fontFamilyDemiBold;
			font-weight: @fontWeightDemiBold;
		}
	}
	.subText {
		margin-top: 15px;
	}
	.buttonWrapper {
		margin: 25px 0 5px;
		width: 50%;
		float: left;

		&.accept {
			padding-left: 10px;
		}
		&.decline {
			padding-right: 10px;
		}
	}
}
</style>
